// Custom Toast
// https://www.youtube.com/watch?v=nX_xDBR_gqo&list=PLC3y8-rFHvwhAh1ypBvcZLDO6I7QTY5CM&index=3
// https://codesandbox.io/s/formik-material-ui-date-picker-with-yup-validate-3odn7?file=/src/index.js:1535-1553

import React from "react";
import FormikControl from "../FormikControls/FormikControls";
import { useForm, FormProvider } from "react-hook-form";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import BasicBodyTheme from "./BasicBodyTheme";
import * as Yup from "yup";
// import { yupResolver } from "@hookform/resolvers";
import { yupResolver } from "@hookform/resolvers/yup";
import { Formik, Form } from "formik";

import Button from "@material-ui/core/Button";

import DateFnsUtils from "@date-io/date-fns";
import "date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";

toast.configure();

function BasicForm() {
  //   return <div className="content-wrapper">Employee</div>;

  const divdataRef = React.createRef();

  const [selectedDate, setSelectedDate] = React.useState(
    new Date("2014-08-18T21:11:54")
  );
  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const initialValues = {
    empname: "",
  };
  const validationSchema = Yup.object({
    empname: Yup.string().required("Required"),
  });

  const methods = useForm({
    resolver: yupResolver(validationSchema),
  });
  const { handleSubmit, errors } = methods;

  const onSubmit = (values) => {
    console.log("Form Data: ", values);
    divdataRef.current.innerHTML = JSON.stringify(values);
    toast.success("Data Saved Successfully!", {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 3000,
    });
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {(formik) => {
        return (
          <Form>
            <FormikControl
              control="input"
              name="empname"
              // required
              label="Name"
              // touched={formik.touched.empname}
              // onChange={formik.onChange}
              // blur={formik.handleBlur}
              // errorobj={formik.errors}
            />
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="Date picker inline"
                value={selectedDate}
                onChange={handleDateChange}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
              />
            </MuiPickersUtilsProvider>
            <br />
            <br />
            {/* <button type="submit" disabled={!formik.isValid}>Submit</button> */}
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={!formik.isValid}
            >
              Submit
            </Button>
            <div ref={divdataRef}>Data</div>
          </Form>
        );
      }}
    </Formik>
  );
}
const WrappedApp = BasicBodyTheme(BasicForm);
// export default Employee;
export default WrappedApp;
